ready(function(){

	const filterCoursesForm = document.getElementById("filterCourses");
	const formationCatsLvl1 = document.getElementById("formationCatsLvl1");
	const formationCatsLvl2 = document.getElementById("formationCatsLvl2");

	if (filterCoursesForm) {
		formationCatsLvl1.addEventListener('change', e => {
			if (parseInt(e.target.value) == 889) {
				formationCatsLvl2.closest('.input').classList.remove('hidden');
			} else {
				formationCatsLvl2.closest('.input').classList.add('hidden');
				formationCatsLvl2.selectedIndex = 0;
			}
		});
	}

});